// src/services/mapConfig.js - ИСПРАВЛЕННАЯ ВЕРСИЯ ДЛЯ ПРОКСИ
import { layers, namedFlavor } from '@protomaps/basemaps';

// ✅ ИСПОЛЬЗУЕМ ПЕРЕМЕННУЮ ОКРУЖЕНИЯ (НЕ ИМПОРТИРУЕМ mapiService!)
const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
console.log('🔧 MapConfig baseUrl:', baseUrl);

const ASSETS_CONFIG = {
  fonts: 'https://mapassets.github.io/map-assets/fonts/{fontstack}/{range}.pbf',
  sprite: 'https://mapassets.github.io/map-assets/sprites/v3/spritemap'
};

const SOURCE_NAME = 'mapi-tiles';

// ✅ ТАЙЛЫ ЧЕРЕЗ ПРОКСИ (БЕЗ API КЛЮЧЕЙ!)
const tileUrlTemplate = `${baseUrl}/tiles/{z}/{x}/{y}`;
console.log('🗺️ TileUrlTemplate:', tileUrlTemplate);

// 🎨 ПОЛНАЯ ЦВЕТОВАЯ ПАЛИТРА
const COLORS = {
  MAP_BACKGROUND: '#0A0A0A',
  LAND_FILL: '#1C1C1E',
  LAND_BORDER: '#2C2C2E',
  
  PARK_FILL: '#29332A',
  PARK_BORDER: '#343F35',
  FOREST_FILL: '#242E25',
  FOREST_BORDER: '#29332A',
  WATER_FILL: '#181A24',
  WATER_BORDER: '#1F2229',
  BEACH_FILL: '#6D4C41',
  MOUNTAIN_FILL: '#3E2723',
  
  BUILDING_FILL: '#161719',
  BUILDING_BORDER: '#1A1C1F',
  RESIDENTIAL_FILL: '#161719',
  COMMERCIAL_FILL: '#161719',
  INDUSTRIAL_FILL: '#161719',
  
  HIGHWAY_LINE: '#1C1C1E',
  HIGHWAY_CASING: '#0F0F10',
  MAJOR_ROAD_LINE: '#252527',
  MAJOR_ROAD_CASING: '#1C1C1E',
  MINOR_ROAD_LINE: '#32323A',
  MINOR_ROAD_CASING: '#252527',
  RESIDENTIAL_LINE: '#4A4A50',
  RESIDENTIAL_CASING: '#32323A',
  PEDESTRIAN_LINE: '#55555A',
  RAILWAY_LINE: '#70707D',
  
  HIGHWAY_TEXT: '#C7C7CC',
  MAJOR_TEXT: '#AEAEB2',
  MINOR_TEXT: '#8E8E93',
  RESIDENTIAL_TEXT: '#6D6D70',
  PEDESTRIAN_TEXT: '#636366',
  
  COUNTRY_TEXT: '#8E8E93',
  STATE_TEXT: '#AEAEB2',
  CITY_TEXT: '#FFFFFF',
  TOWN_TEXT: '#E5E5E7',
  VILLAGE_TEXT: '#C7C7CC',
  NEIGHBORHOOD_TEXT: '#AEAEB2',
  
  TEXT_HALO_BLACK: '#000000',
  TEXT_HALO_DARK: '#1C1C1E',
  TEXT_HALO_MEDIUM: '#2C2C2E',
  BORDER_THIN: '#3A3A3C',
  BORDER_THICK: '#48484A',
  SHADOW: '#000000',
  
  HIGHLIGHT: '#007AFF',
  SELECTION: '#34C759',
  ACTIVE: '#FF453A',
  HOVER: '#FF9F0A',

  // 🆕 НОВЫЕ ЦВЕТА ДЛЯ ЭФФЕКТОВ
  BUILDING_SHADOW: '#000000',
  BUILDING_HIGHLIGHT: '#2A2D33',
  HIGHWAY_GLOW: '#2A2A2C',
  POI_GLOW: '#007AFF',
  WATER_ANIMATED: '#151A26',

  // 🆕 УЛУЧШЕННЫЕ ЦВЕТА ДЛЯ ОБЪЕМНЫХ ТЕНЕЙ
  BUILDING_SHADOW_DEEP: '#000000',
  BUILDING_SHADOW_SOFT: '#0A0A0A',
  BUILDING_HIGHLIGHT: '#383B42',
  BUILDING_EDGE_LIGHT: '#4A4D54',
  BUILDING_AMBIENT: '#2A2D33',

  // 🏠 НОМЕРА ДОМОВ
  HOUSE_NUMBER_TEXT: '#AEAEB2', // 🔥 ЯРКО-ЖЕЛТЫЙ ДЛЯ ОТЛАДКИ
  HOUSE_NUMBER_HALO: '#000000'
};

// 🎨 ЦВЕТА ТЕКСТА POI ПО ТИПУ ИКОНКИ - РЕДАКТИРУЕМЫЕ
const POI_ICON_COLORS = {
  // 🏥 МЕДИЦИНА И ЭКСТРЕННЫЕ СЛУЖБЫ - Красные оттенки
  'hospital-dark': '#E97D7D',
  'fire-station-dark': '#A3B4C3',
  'police-dark': '#A3B4C3',
  'pharmacy-dark': '#E97D7D',
  'dentist-dark': '#FF9F43',
  'doctor-dark': '#FF6B6B',
  'veterinary-dark': '#A55EEA',

  // ✈️ ТРАНСПОРТ - Синие оттенки  
  'airport-dark': '#5579CA',
  'rail-dark': '#5579CA',
  'bus-dark': '#5579CA',
  'ferry-dark': '#5579CA',
  'car-rental-dark': '#5579CA',
  'charging-station-dark': '#A17DE8',
  'bicycle-dark': '#5579CA',

  // 🏛️ ГОСУДАРСТВЕННЫЕ И ОБЩЕСТВЕННЫЕ - Золотые оттенки
  'town-hall-dark': '#A3B4C3',
  'courthouse-dark': '#FFA726',
  'post-dark': '#A3B4C3',
  'bank-dark': '#A17DE8',
  'information-dark': '#70A1FF',

  // 🎓 ОБРАЗОВАНИЕ И КУЛЬТУРА - Фиолетовые оттенки
  'school-dark': '#D8B68B',
  'college-dark': '#D8B68B',
  'library-dark': '#A3B4C3',
  'museum-dark': '#EC93CE',
  'theatre-dark': '#EC93CE',
  'attraction-dark': '#EC93CE',

  // 🛍️ ТОРГОВЛЯ И УСЛУГИ - Зеленые оттенки
  'grocery-dark': '#93C1ED',
  'convenience-dark': '#93C1ED',
  'restaurant-dark': '#D8B68B',
  'cafe-dark': '#D8B68B',
  'bar-dark': '#D8B68B',

  // 🏨 РАЗМЕЩЕНИЕ - Синие оттенки
  'lodging-dark': '#A17DE8',
  'hotel-dark': '#A17DE8',

  // ⛽ ТОПЛИВО И АВТОСЕРВИС - Оранжевые оттенки
  'fuel-dark': '#A17DE8',
  'gas-station-dark': '#A17DE8',

  // 🌳 ПРИРОДА И ОТДЫХ - Зеленые оттенки
  'park-dark': '#85D775',
  'garden-dark': '#55EFC4',
  'playground-dark': '#81ECEC',
  'amusement-park-dark': '#EC93CE',
  'zoo-dark': '#FDCB6E',

  // 🏃 СПОРТ И ФИТНЕС - Оранжевые оттенки  
  'fitness-centre-dark': '#FF7675',
  'swimming-dark': '#74B9FF',
  'tennis-dark': '#FDCB6E',

  // 💼 ОФИСЫ И БИЗНЕС - Серые оттенки
  'office-dark': '#B2BEC3',
  'commercial-dark': '#DDD',

  // 🏠 СПЕЦИАЛЬНЫЕ ОБЪЕКТЫ
  'place-of-worship-dark': '#A29BFE',
  'cemetery-dark': '#636E72',
  'monument-dark': '#DCDDE1',
  'castle-dark': '#FDCB6E',
  'tower-dark': '#B2BEC3',
  'lighthouse-dark': '#74B9FF',
  'viewpoint-dark': '#00CEC9',

  // 🔧 ТЕХНИЧЕСКИЕ И УТИЛИТЫ
  'hardware-dark': '#95A5A6',
  'laundry-dark': '#74B9FF',
  'mobile-phone-dark': '#6C5CE7',
  'toilet-dark': '#B2BEC3',
  'parking-dark': '#95A5A6',

  // 🎯 FALLBACK ДЛЯ НЕИЗВЕСТНЫХ ИКОНОК
  'default': '#B2BEC3'
};

// 🎯 АДАПТИРОВАННЫЕ POI ПОД MAXZOOM 15 (PROTOMAPS) С ЦВЕТАМИ ПО ИКОНКАМ
const POI_TIER_1 = {
  // КРИТИЧЕСКИ ВАЖНЫЕ POI (зум 10-11) - самые важные для навигации
  'hospital': { 
    icon: 'hospital-dark', 
    size: 1, 
    minzoom: 11.5, 
    textColor: POI_ICON_COLORS['hospital-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'aerodrome': { 
    icon: 'airport-dark', 
    size: 1, 
    minzoom: 11.5, 
    textColor: POI_ICON_COLORS['airport-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'uppercase' 
  },
  'airfield': { 
    icon: 'airport-dark', 
    size: 1, 
    minzoom: 11.5, 
    textColor: POI_ICON_COLORS['airport-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'uppercase' 
  },
  'airport': { 
    icon: 'airport-dark', 
    size: 1, 
    minzoom: 11.5, 
    textColor: POI_ICON_COLORS['airport-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'uppercase' 
  },
  'station': { 
    icon: 'rail-dark', 
    size: 1, 
    minzoom: 11.5, 
    textColor: POI_ICON_COLORS['rail-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'train_station': { 
    icon: 'rail-dark', 
    size: 1, 
    minzoom: 11.5, 
    textColor: POI_ICON_COLORS['rail-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'subway_station': { 
    icon: 'rail-dark', 
    size: 1, 
    minzoom: 11.5, 
    textColor: POI_ICON_COLORS['rail-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'university': { 
    icon: 'college-dark', 
    size: 1, 
    minzoom: 11.5, 
    textColor: POI_ICON_COLORS['college-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'fire_station': { 
    icon: 'fire-station-dark', 
    size: 1, 
    minzoom: 11.5, 
    textColor: POI_ICON_COLORS['fire-station-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'police': { 
    icon: 'police-dark', 
    size: 1, 
    minzoom: 11.5, 
    textColor: POI_ICON_COLORS['police-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'townhall': { 
    icon: 'town-hall-dark', 
    size: 1, 
    minzoom: 11.5, 
    textColor: POI_ICON_COLORS['town-hall-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'courthouse': { 
    icon: 'town-hall-dark', 
    size: 1, 
    minzoom: 11.5, 
    textColor: POI_ICON_COLORS['town-hall-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'mall': { 
    icon: 'grocery-dark', 
    size: 1, 
    minzoom: 11.5, 
    textColor: POI_ICON_COLORS['grocery-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'shopping_mall': { 
    icon: 'grocery-dark', 
    size: 1, 
    minzoom: 11.5, 
    textColor: POI_ICON_COLORS['grocery-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
};

const POI_TIER_2 = {
  // ВАЖНЫЕ POI ДЛЯ ПОВСЕДНЕВНОЙ ЖИЗНИ (зум 12-13)
  'hotel': { 
    icon: 'lodging-dark', 
    size: 1, 
    minzoom: 12, 
    textColor: POI_ICON_COLORS['lodging-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'lodging': { 
    icon: 'lodging-dark', 
    size: 1, 
    minzoom: 12, 
    textColor: POI_ICON_COLORS['lodging-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'guest_house': { 
    icon: 'lodging-dark', 
    size: 1, 
    minzoom: 13, 
    textColor: POI_ICON_COLORS['lodging-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'hostel': { 
    icon: 'lodging-dark', 
    size: 1, 
    minzoom: 13, 
    textColor: POI_ICON_COLORS['lodging-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  
  'restaurant': { 
    icon: 'restaurant-dark', 
    size: 1, 
    minzoom: 12, 
    textColor: POI_ICON_COLORS['restaurant-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'fast_food': { 
    icon: 'restaurant-dark', 
    size: 1, 
    minzoom: 13, 
    textColor: POI_ICON_COLORS['restaurant-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'food_court': { 
    icon: 'restaurant-dark', 
    size: 1, 
    minzoom: 13, 
    textColor: POI_ICON_COLORS['restaurant-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  
  'fuel': { 
    icon: 'fuel-dark', 
    size: 1, 
    minzoom: 12, 
    textColor: POI_ICON_COLORS['fuel-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'gas_station': { 
    icon: 'fuel-dark', 
    size: 1, 
    minzoom: 12, 
    textColor: POI_ICON_COLORS['fuel-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  
  'supermarket': { 
    icon: 'grocery-dark', 
    size: 1, 
    minzoom: 12, 
    textColor: POI_ICON_COLORS['grocery-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'department_store': { 
    icon: 'grocery-dark', 
    size: 1, 
    minzoom: 12, 
    textColor: POI_ICON_COLORS['grocery-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  
  'bank': { 
    icon: 'bank-dark', 
    size: 1, 
    minzoom: 12, 
    textColor: POI_ICON_COLORS['bank-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'school': { 
    icon: 'school-dark', 
    size: 1, 
    minzoom: 12, 
    textColor: POI_ICON_COLORS['school-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'college': { 
    icon: 'college-dark', 
    size: 1, 
    minzoom: 12, 
    textColor: POI_ICON_COLORS['college-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'library': { 
    icon: 'library-dark', 
    size: 1, 
    minzoom: 12, 
    textColor: POI_ICON_COLORS['library-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'pharmacy': { 
    icon: 'pharmacy-dark', 
    size: 1, 
    minzoom: 12, 
    textColor: POI_ICON_COLORS['pharmacy-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'post_office': { 
    icon: 'post-dark', 
    size: 1, 
    minzoom: 12, 
    textColor: POI_ICON_COLORS['post-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  
  'museum': { 
    icon: 'museum-dark', 
    size: 1, 
    minzoom: 12, 
    textColor: POI_ICON_COLORS['museum-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'gallery': { 
    icon: 'museum-dark', 
    size: 1, 
    minzoom: 13, 
    textColor: POI_ICON_COLORS['museum-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'theatre': { 
    icon: 'theatre-dark', 
    size: 1, 
    minzoom: 12, 
    textColor: POI_ICON_COLORS['theatre-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'cinema': { 
    icon: 'theatre-dark', 
    size: 1, 
    minzoom: 13, 
    textColor: POI_ICON_COLORS['theatre-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },

  // Крупные спортивные и развлекательные объекты
  'stadium': { 
    icon: 'park-dark', 
    size: 1, 
    minzoom: 11, 
    textColor: POI_ICON_COLORS['park-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'golf_course': { 
    icon: 'park-dark', 
    size: 1, 
    minzoom: 12, 
    textColor: POI_ICON_COLORS['park-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'zoo': { 
    icon: 'park-dark', 
    size: 1, 
    minzoom: 12, 
    textColor: POI_ICON_COLORS['park-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'arts_centre': { 
    icon: 'museum-dark', 
    size: 1, 
    minzoom: 12, 
    textColor: POI_ICON_COLORS['museum-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'amusement_park': { 
    icon: 'amusement-park-dark', 
    size: 1, 
    minzoom: 12, 
    textColor: POI_ICON_COLORS['amusement-park-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'theme_park': { 
    icon: 'amusement-park-dark', 
    size: 1, 
    minzoom: 12, 
    textColor: POI_ICON_COLORS['amusement-park-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },

  // Крупные общественные объекты
  'community_centre': { 
    icon: 'town-hall-dark', 
    size: 1, 
    minzoom: 12, 
    textColor: POI_ICON_COLORS['town-hall-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'events_venue': { 
    icon: 'theatre-dark', 
    size: 1, 
    minzoom: 12, 
    textColor: POI_ICON_COLORS['theatre-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'marina': { 
    icon: 'ferry-dark', 
    size: 1, 
    minzoom: 12, 
    textColor: POI_ICON_COLORS['ferry-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
 };

const POI_TIER_3 = {
  // ДЕТАЛЬНЫЕ POI (зум 14) - много мусорных POI, показываем только на предпоследнем зуме
  
  // Еда и напитки - детальные
  'cafe': { 
    icon: 'cafe-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['cafe-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'coffee_shop': { 
    icon: 'cafe-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['cafe-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'bakery': { 
    icon: 'cafe-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['cafe-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'ice_cream': { 
    icon: 'cafe-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['cafe-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'bar': { 
    icon: 'bar-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['bar-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'pub': { 
    icon: 'bar-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['bar-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'nightclub': { 
    icon: 'bar-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['bar-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'bistro': { 
    icon: 'restaurant-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['restaurant-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'butcher': { 
    icon: 'grocery-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['grocery-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'seafood': { 
    icon: 'grocery-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['grocery-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'confectionery': { 
    icon: 'cafe-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['cafe-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'tea': { 
    icon: 'cafe-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['cafe-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'coffee': { 
    icon: 'cafe-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['cafe-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'pastry': { 
    icon: 'cafe-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['cafe-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'food': { 
    icon: 'restaurant-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['restaurant-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'hookah_lounge': { 
    icon: 'cafe-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['cafe-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'hookah': { 
    icon: 'cafe-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['cafe-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'internet_cafe': { 
    icon: 'cafe-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['cafe-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'caterer': { 
    icon: 'restaurant-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['restaurant-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'alcohol': { 
    icon: 'grocery-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['grocery-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'wine': { 
    icon: 'grocery-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['grocery-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'beverages': { 
    icon: 'grocery-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['grocery-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'cheese': { 
    icon: 'grocery-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['grocery-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'deli': { 
    icon: 'grocery-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['grocery-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'honey': { 
    icon: 'grocery-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['grocery-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'dairy': { 
    icon: 'grocery-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['grocery-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'spices': { 
    icon: 'grocery-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['grocery-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'convenience': { 
    icon: 'convenience-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['convenience-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'grocery': { 
    icon: 'grocery-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['grocery-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'shop': { 
    icon: 'convenience-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['convenience-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'retail': { 
    icon: 'convenience-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['convenience-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'store': { 
    icon: 'convenience-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['convenience-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'market': { 
    icon: 'grocery-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['grocery-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'marketplace': { 
    icon: 'grocery-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['grocery-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'bookstore': { 
    icon: 'library-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['library-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'greengrocer': { 
    icon: 'grocery-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['grocery-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'clothing_store': { 
    icon: 'convenience-dark', 
    size: 1, 
    minzoom: 14.8, 
    textColor: POI_ICON_COLORS['convenience-dark'], 
    textSize: 9, 
    textFont: ['Noto Sans Medium'], 
    showText: true, 
    textTransform: 'none' 
  },
  'shoes': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'jewelry': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'electronics': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'mobile_phone': { icon: 'mobile-phone-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'computer': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'furniture': { icon: 'furniture', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'hardware': { icon: 'hardware-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'gift': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'beauty': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'clothes': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'books': { icon: 'library-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'music': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'games': { icon: 'playground-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'toys': { icon: 'playground-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'newsagent': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'kiosk': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'lottery': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'gambling': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'adult_gaming_centre': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'garden_centre': { icon: 'garden-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'florist': { icon: 'garden-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'fabric': { icon: 'information-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'leather': { icon: 'information-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'watches': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'jeweller': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'hifi': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'car_parts': { icon: 'car-rental-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'carpet': { icon: 'furniture', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'houseware': { icon: 'furniture', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'flooring': { icon: 'hardware-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'fashion_accessories': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'dentist': { icon: 'dentist-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'doctors': { icon: 'doctor-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'clinic': { icon: 'hospital-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'veterinary': { icon: 'veterinary-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'optician': { icon: 'doctor-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'medical_supply': { icon: 'pharmacy-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'chemist': { icon: 'pharmacy-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'herbalist': { icon: 'pharmacy-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'veterinary_pharmacy': { icon: 'pharmacy-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'mortuary': { icon: 'hospital-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'bus_stop': { icon: 'bus-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'bus_station': { icon: 'bus-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'tram_stop': { icon: 'rail-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'taxi': { icon: 'bus-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'car_rental': { icon: 'car-rental-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'bicycle_rental': { icon: 'bicycle-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'charging_station': { icon: 'charging-station-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'device_charging_station': { icon: 'charging-station-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'car_wash': { icon: 'car-rental-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'car_sharing': { icon: 'car-rental-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'platform': { icon: 'rail-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'ferry_terminal': { icon: 'ferry-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'helipad': { icon: 'airfield-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'car': { icon: 'car-rental-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'motorcycle': { icon: 'car-rental-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'parking': { icon: 'parking-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'atm': { icon: 'bank-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'toilets': { icon: 'toilet-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'bicycle_parking': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'waste_disposal': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'vending_machine': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'bench': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'waste_basket': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'post_box': { icon: 'post-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'payment_terminal': { icon: 'bank-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'parking_entrance': { icon: 'parking-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'motorcycle_parking': { icon: 'parking-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'scooter_parking': { icon: 'parking-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'kick_scooter_parking': { icon: 'parking-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'kick-scooter_parking': { icon: 'parking-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'telephone': { icon: 'mobile-phone-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'emergency_phone': { icon: 'mobile-phone-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'recycling': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'smoking_area': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'parcel_locker': { icon: 'post-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'post_locker': { icon: 'post-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'ticket_validator': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  // 'hairdresser': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'beauty_salon': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'nail_salon': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'spa': { icon: 'lodging-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'massage': { icon: 'lodging-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'sauna': { icon: 'lodging-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'laundry': { icon: 'laundry-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'dry_cleaning': { icon: 'laundry-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'gym': { icon: 'fitness-centre-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'fitness_centre': { icon: 'fitness-centre-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'sports_centre': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'swimming_pool': { icon: 'swimming-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'tennis': { icon: 'tennis-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'golf': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'playground': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'park': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'garden': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'picnic_site': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'picnic_table': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'sports_hall': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'swimming_area': { icon: 'swimming-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'dog_park': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'dancing': { icon: 'theatre-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'carousel': { icon: 'amusement-park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'amusement_ride': { icon: 'amusement-park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'roller_coaster': { icon: 'amusement-park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'water_slide': { icon: 'swimming-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'summer_toboggan': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'hairdresser_supply': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'locksmith': { icon: 'hardware-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'translation': { icon: 'information-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'church': { icon: 'place-of-worship-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'mosque': { icon: 'place-of-worship-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'synagogue': { icon: 'place-of-worship-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'temple': { icon: 'place-of-worship-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'place_of_worship': { icon: 'place-of-worship-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'cemetery': { icon: 'cemetery-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'attraction': { icon: 'attraction-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'monument': { icon: 'monument-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'memorial': { icon: 'monument-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'castle': { icon: 'castle-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'tower': { icon: 'tower-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'lighthouse': { icon: 'lighthouse-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'viewpoint': { icon: 'viewpoint-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'aquarium': { icon: 'aquarium-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'archaeological_site': { icon: 'attraction-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'landmark': { icon: 'monument-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'wayside_cross': { icon: 'monument-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'culture_center': { icon: 'museum-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'office': { icon: 'information-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'information': { icon: 'information-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'tourist_info': { icon: 'information-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'public_building': { icon: 'town-hall-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'customs': { icon: 'town-hall-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'animal': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'pet': { icon: 'veterinary-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'forest': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'nature_reserve': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'peak': { icon: 'viewpoint-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'childcare': { icon: 'school-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'kindergarten': { icon: 'school-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'military': { icon: 'police-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'naval_base': { icon: 'police-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'alpine_hut': { icon: 'lodging-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'wilderness_hut': { icon: 'lodging-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'chalet': { icon: 'lodging-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'bed_and_breakfast': { icon: 'lodging-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'photo': { icon: 'museum-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'photographic_laboratory': { icon: 'information-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'art': { icon: 'museum-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'manor': { icon: 'attraction-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'neighbourhood': { icon: 'information-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'district': { icon: 'information-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'vacant': { icon: 'information-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'city_gate': { icon: 'monument-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'bandstand': { icon: 'theatre-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'stripclub': { icon: 'bar-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'anime': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'fountain': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'clock': { icon: 'museum-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'drinking_water': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'water_point': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'shower': { icon: 'lodging-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'outdoor': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'bureau_de_change': { icon: 'bank-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'pawnbroker': { icon: 'bank-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'artwork': { icon: 'attraction-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'erotic': { icon: 'bar-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'dock': { icon: 'ferry-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'camp_site': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'pier': { icon: 'ferry-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'pitch': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'travel_agency': { icon: 'information-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'electronics_repair': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'cosmetics': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'tobacco': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'perfumery': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'copyshop': { icon: 'information-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'tailor': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'language_school': { icon: 'school-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'music_school': { icon: 'school-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'event_venue': { icon: 'theatre-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'coworking_space': { icon: 'information-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'studio': { icon: 'information-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'religion': { icon: 'place-of-worship-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'dormitory': { icon: 'lodging-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'suburb': { icon: 'information-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'ticket': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'fitness_station': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'outdoor_seating': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'musical_instrument': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'karaoke_box': { icon: 'bar-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'escape_game': { icon: 'playground-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'dance': { icon: 'theatre-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'money_transfer': { icon: 'bank-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'key_cutter': { icon: 'hardware-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'shoe_repair': { icon: 'hardware-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'photo_lab': { icon: 'information-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'photographer': { icon: 'information-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'bag': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'stationery': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'antiques': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'baby_goods': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'health_food': { icon: 'grocery-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'hearing_aids': { icon: 'doctor-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'doors': { icon: 'hardware-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'training': { icon: 'school-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'monastery': { icon: 'place-of-worship-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'social_facility': { icon: 'hospital-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'research_institute': { icon: 'college-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'shelter': { icon: 'hospital-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'car_repair': { icon: 'bus-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'farm': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'post_depot': { icon: 'post-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'outpost': { icon: 'town-hall-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'bookmaker': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'fashion': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'fishing': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'hanami': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'harbourmaster': { icon: 'marina-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'hunting_stand': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'karaoke': { icon: 'bar-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'life_ring': { icon: 'ferry-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'maze': { icon: 'amusement-park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'ranger_station': { icon: 'police-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'sanitary_dump_station': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'scuba_diving': { icon: 'swimming-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'ship_chandler': { icon: 'ferry-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'slipway': { icon: 'ferry-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'snowmobile': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'trail_riding_station': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'watering_place': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'atv': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'baby_hatch': { icon: 'hospital-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'bbq': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'beach': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'bicycle_repair_station': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'boat_storage': { icon: 'ferry-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'firepit': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'cigarette': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'bicycle_brothel': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'huning': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'hunting': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'frame': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'craft': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'social_centre': { icon: 'town-hall-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'dancing_school': { icon: 'school-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'esoteric': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'e-cigarette': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'interior_decoration': { icon: 'furniture', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'clockmaker': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'tattoo': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'sewing': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'repair': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'pet_grooming': { icon: 'veterinary-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'amusement_arcade': { icon: 'playground-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'sports': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'public_service': { icon: 'town-hall-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'kids_area': { icon: 'playground-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'security_booth': { icon: 'police-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'bicycle': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'commercial': { icon: 'information-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'kitchen': { icon: 'furniture', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'wigs': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'paint': { icon: 'hardware-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'power_tools': { icon: 'hardware-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'variety_store': { icon: 'grocery-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'tyres': { icon: 'bus-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'storage_rental': { icon: 'information-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'rental': { icon: 'bus-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'boat_rental': { icon: 'ferry-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'tiles': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'ruins': { icon: 'museum-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'pyrotechnics': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'driving_school': { icon: 'school-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'photo_booth': { icon: 'information-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'estate_agent': { icon: 'information-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'newspaper': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'vehicle_inspection': { icon: 'bus-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'party': { icon: 'theatre-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'second_hand': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'video': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'paintball': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'heritage': { icon: 'museum-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'bowling_alley': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'money_lender': { icon: 'bank-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'hotel_goods': { icon: 'lodging-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'prison': { icon: 'police-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'safety_equipment': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'building': { icon: 'information-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'model': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'feeding_place': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'ice_rink': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'lounger': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'sanatorium': { icon: 'hospital-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'farmyard': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'beach_resort': { icon: 'lodging-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'tree': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: false, textTransform: 'none' },
  'spa_resort': { icon: 'lodging-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'shoemaker': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'mobile_phones': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'agrarian': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'animal_shelter': { icon: 'veterinary-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'curtain': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'tanning': { icon: 'lodging-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'trampoline_park': { icon: 'playground-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'fireplace': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'pottery': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'tomb': { icon: 'cemetery-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'funeral_hall': { icon: 'cemetery-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'stamps': { icon: 'post-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'trade': { icon: 'information-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'weapons': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'doityourself': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'electrical': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'watchmaker': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'grave_yard': { icon: 'cemetery-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'apartment': { icon: 'lodging-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'collector': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'bell': { icon: 'museum-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'engraver': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'wedding': { icon: 'information-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'packaging': { icon: 'information-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'bed': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'window_construction': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'water_filter': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'funeral_directors': { icon: 'cemetery-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'wool': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'payment_centre': { icon: 'bank-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'cannon': { icon: 'museum-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'heritage_building': { icon: 'museum-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'vehicle': { icon: 'bus-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'boutique': { icon: 'convenience-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' },
  'gardener': { icon: 'park-dark', size: 1, minzoom: 14.8, textColor: COLORS.POI_TEXT_TERTIARY, textSize: 9, textFont: ['Noto Sans Medium'], showText: true, textTransform: 'none' }
};

const POI_ICON_MAPPING = {
  ...POI_TIER_1,
  ...POI_TIER_2,
  ...POI_TIER_3
};

// 🚀 КЕШИРОВАННЫЕ ФУНКЦИИ
const layerCache = new Map();

function memoizeLayer(key, layerFactory) {
  if (!layerCache.has(key)) {
    layerCache.set(key, layerFactory());
  }
  return layerCache.get(key);
}

// Вспомогательная функция для конвертации координат в тайл
function latLngToTile(lat, lng, zoom) {
  const latRad = lat * Math.PI / 180;
  const n = Math.pow(2, zoom);
  return {
    x: Math.floor((lng + 180) / 360 * n),
    y: Math.floor((1 - Math.asinh(Math.tan(latRad)) / Math.PI) / 2 * n),
    z: zoom
  };
}

// 🌊 ПЛАВНЫЕ СЛОИ LANDUSE (БЕЗ ПУСТЫХ ЗУМОВ)
function createLanduseLayers() {
  return memoizeLayer('landuse', () => [
    // 💫 АНИМИРОВАННАЯ ВОДА с эффектом мерцания
    {
      id: 'landuse-water-animated',
      type: 'fill',
      source: SOURCE_NAME,
      'source-layer': 'water',
      minzoom: 0,
      paint: {
        'fill-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          0, '#151A26',
          8, '#181A24',
          12, '#1A1C26',
          16, '#1C1E28'
        ],
        'fill-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          0, 0.6,
          8, 0.8,
          16, 0.9
        ]
      }
    },
    // 🌳 ПАРКИ
    {
      id: 'landuse-park',
      type: 'fill',
      source: SOURCE_NAME,
      'source-layer': 'landuse',
      filter: ['in', 'kind', 'park', 'garden', 'recreation_ground'],
      minzoom: 8,
      paint: {
        'fill-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          8, '#27312A',
          12, '#29332A',
          16, '#2B352C'
        ],
        'fill-opacity': ['interpolate', ['linear'], ['zoom'], 8, 0.3, 12, 0.6, 16, 0.8]
      }
    },
    // 🌲 ЛЕСА
    {
      id: 'landuse-forest',
      type: 'fill',
      source: SOURCE_NAME,
      'source-layer': 'landuse',
      filter: ['in', 'kind', 'forest', 'wood'],
      minzoom: 6,
      paint: {
        'fill-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          6, '#222E23',
          10, '#242E25',
          16, '#263027'
        ],
        'fill-opacity': ['interpolate', ['linear'], ['zoom'], 6, 0.4, 10, 0.7, 16, 0.8]
      }
    }
  ]);
}

// 🏢 ЗДАНИЯ С ОБЪЕМНЫМИ ТЕНЯМИ
function createBuildingLayers() {
  return memoizeLayer('buildings', () => [
    // 🌚 ГЛУБОКАЯ ТЕНЬ (самая дальняя и размытая)
    {
      id: 'buildings-shadow-far',
      type: 'fill',
      source: SOURCE_NAME,
      'source-layer': 'buildings',
      minzoom: 12,
      paint: {
        'fill-color': '#000000',
        'fill-opacity': ['interpolate', ['linear'], ['zoom'], 12, 0.15, 16, 0.25, 18, 0.3],
        'fill-translate': [
          'interpolate', 
          ['linear'], 
          ['zoom'],
          12, ['literal', [8, 6]],
          16, ['literal', [20, 15]], 
          20, ['literal', [35, 25]]
        ],
        'fill-translate-anchor': 'map'
      }
    },
    
    // 🌑 СРЕДНЯЯ ТЕНЬ (промежуточный слой)
    {
      id: 'buildings-shadow-mid',
      type: 'fill',
      source: SOURCE_NAME,
      'source-layer': 'buildings',
      minzoom: 12,
      paint: {
        'fill-color': '#000000',
        'fill-opacity': ['interpolate', ['linear'], ['zoom'], 12, 0.2, 16, 0.35, 18, 0.4],
        'fill-translate': [
          'interpolate', 
          ['linear'], 
          ['zoom'],
          12, ['literal', [5, 4]],
          16, ['literal', [12, 9]], 
          20, ['literal', [20, 15]]
        ],
        'fill-translate-anchor': 'map'
      }
    },

    // 🖤 КОНТАКТНАЯ ТЕНЬ (самая близкая и темная)
    {
      id: 'buildings-shadow-contact',
      type: 'fill',
      source: SOURCE_NAME,
      'source-layer': 'buildings',
      minzoom: 12,
      paint: {
        'fill-color': '#000000',
        'fill-opacity': ['interpolate', ['linear'], ['zoom'], 12, 0.25, 16, 0.45, 18, 0.55],
        'fill-translate': [
          'interpolate', 
          ['linear'], 
          ['zoom'],
          12, ['literal', [2, 1]],
          16, ['literal', [6, 4]], 
          20, ['literal', [10, 7]]
        ],
        'fill-translate-anchor': 'map'
      }
    },

    // 💫 РАЗМЫТЫЕ КОНТУРЫ ТЕНЕЙ (line-based shadow для soft edges)
    {
      id: 'buildings-shadow-soft',
      type: 'line',
      source: SOURCE_NAME,
      'source-layer': 'buildings',
      minzoom: 14,
      paint: {
        'line-color': '#000000',
        'line-width': ['interpolate', ['linear'], ['zoom'], 14, 8, 18, 20, 20, 30],
        'line-blur': ['interpolate', ['linear'], ['zoom'], 14, 6, 18, 15, 20, 25],
        'line-opacity': ['interpolate', ['linear'], ['zoom'], 14, 0.1, 16, 0.2, 18, 0.25],
        'line-translate': [
          'interpolate', 
          ['linear'], 
          ['zoom'],
          14, ['literal', [8, 6]],
          18, ['literal', [15, 11]], 
          20, ['literal', [25, 18]]
        ],
        'line-translate-anchor': 'map'
      }
    },

    // 🏢 ОСНОВНЫЕ ЗДАНИЯ (поверх всех теней)
    {
      id: 'buildings-fill',
      type: 'fill',
      source: SOURCE_NAME,
      'source-layer': 'buildings',
      minzoom: 12,
      paint: {
        'fill-color': [
          'case',
          ['==', ['get', 'building'], 'residential'], '#1A1C1F',
          ['==', ['get', 'building'], 'commercial'], '#1C1E21', 
          ['==', ['get', 'building'], 'office'], '#1E2024',
          ['==', ['get', 'building'], 'industrial'], '#181A1D',
          COLORS.BUILDING_FILL
        ],
        'fill-opacity': ['interpolate', ['linear'], ['zoom'], 12, 0.3, 14, 0.7, 16, 0.95, 18, 1.0]
      }
    },

    // ✨ ПОДСВЕТКА (световые грани зданий - противоположная сторона от тени)
    {
      id: 'buildings-highlight',
      type: 'line',
      source: SOURCE_NAME,
      'source-layer': 'buildings',
      minzoom: 15,
      paint: {
        'line-color': COLORS.BUILDING_HIGHLIGHT,
        'line-width': ['interpolate', ['linear'], ['zoom'], 15, 0.5, 18, 1.5, 20, 2],
        'line-opacity': ['interpolate', ['linear'], ['zoom'], 15, 0.3, 18, 0.6, 20, 0.8],
        'line-translate': [
          'interpolate', 
          ['linear'], 
          ['zoom'],
          15, ['literal', [-1, -1]], // Противоположное направление от тени
          18, ['literal', [-2, -2]], 
          20, ['literal', [-3, -3]]
        ],
        'line-translate-anchor': 'map'
      }
    },

    // 🔳 ГРАНИЦЫ ЗДАНИЙ (финальные контуры)
    {
      id: 'buildings-border',
      type: 'line',
      source: SOURCE_NAME,
      'source-layer': 'buildings',
      minzoom: 16,
      paint: {
        'line-color': '#2A2D33',
        'line-width': ['interpolate', ['linear'], ['zoom'], 16, 0.3, 18, 0.8, 20, 1.2],
        'line-opacity': ['interpolate', ['linear'], ['zoom'], 16, 0.4, 18, 0.7, 20, 0.9]
      }
    }
  ]);
}

// 🏠 НОМЕРА ДОМОВ С ПРАВИЛЬНЫМИ ПОЛЯМИ
function createHouseNumberLayers() {
  return memoizeLayer('houseNumbers', () => [
    // 🏠 НОМЕРА ДОМОВ ИЗ BUILDINGS LAYER - ИСПРАВЛЕННЫЕ ПОЛЯ
    {
      id: 'house-numbers-buildings',
      type: 'symbol',
      source: SOURCE_NAME,
      'source-layer': 'buildings',
      filter: [
        'any',
        ['has', 'addr_housenumber'], // 🔥 ИСПРАВЛЕНО: подчеркивание вместо двоеточия
        ['has', 'housenumber'],
        ['has', 'ref'],
        ['has', 'name']
      ],
      minzoom: 17, // 🔥 ПОНИЖЕН ДО 14 ДЛЯ ОТЛАДКИ
      layout: {
        'text-field': [
          'coalesce',
          ['get', 'addr_housenumber'], // 🔥 ИСПРАВЛЕНО: подчеркивание
          ['get', 'housenumber'], 
          ['get', 'ref'],
          ['get', 'name']
        ],
        'text-font': ['Noto Sans Medium'],
        'text-size': [
          'interpolate',
          ['linear'],
          ['zoom'],
          16, 10
        ],
        'text-allow-overlap': false, // 🔥 РАЗРЕШАЕМ ПЕРЕКРЫТИЕ ДЛЯ ОТЛАДКИ
        'text-ignore-placement': false, // 🔥 ИГНОРИРУЕМ РАЗМЕЩЕНИЕ
        'text-padding': 1,
        'text-rotation-alignment': 'viewport',
        'text-pitch-alignment': 'viewport'
      },
      paint: {
        'text-color': COLORS.HOUSE_NUMBER_TEXT, // 🔥 ЯРКО-ЖЕЛТЫЙ
        'text-halo-color': COLORS.HOUSE_NUMBER_HALO,
        'text-halo-width': 1, // 🔥 ТОЛСТАЯ ОБВОДКА
        'text-opacity': 1.0
      }
    },

    // 🏠 НОМЕРА ДОМОВ ИЗ POIS LAYER (если есть)
    {
      id: 'house-numbers-pois',
      type: 'symbol',
      source: SOURCE_NAME,
      'source-layer': 'pois',
      filter: [
        'any',
        ['has', 'addr_housenumber'], // 🔥 ИСПРАВЛЕНО
        ['has', 'housenumber'],
        ['has', 'ref']
      ],
      minzoom: 17,
      layout: {
        'text-field': [
          'coalesce',
          ['get', 'addr_housenumber'], // 🔥 ИСПРАВЛЕНО
          ['get', 'housenumber'],
          ['get', 'ref']
        ],
        'text-font': ['Noto Sans Medium'],
        'text-size': [
          'interpolate',
          ['linear'],
          ['zoom'],
          16, 10
        ],
        'text-allow-overlap': false, // 🔥 РАЗРЕШАЕМ ПЕРЕКРЫТИЕ ДЛЯ ОТЛАДКИ
        'text-ignore-placement': false, // 🔥 ИГНОРИРУЕМ РАЗМЕЩЕНИЕ
        'text-padding': 1,
        'text-rotation-alignment': 'viewport',
        'text-pitch-alignment': 'viewport'
      },
      paint: {
        'text-color': '#00FFFF', // 🔥 CYAN ДЛЯ ОТЛИЧИЯ
        'text-halo-color': '#000000',
        'text-halo-width': 1,
        'text-opacity': 1.0
      }
    },

    // 🏠 НОМЕРА ДОМОВ ИЗ PLACES LAYER (если есть)
    {
      id: 'house-numbers-places',
      type: 'symbol',
      source: SOURCE_NAME,
      'source-layer': 'places',
      filter: [
        'any',
        ['has', 'addr_housenumber'], // 🔥 ИСПРАВЛЕНО
        ['has', 'housenumber'],
        ['has', 'ref']
      ],
      minzoom: 17,
      layout: {
        'text-field': [
          'coalesce',
          ['get', 'addr_housenumber'], // 🔥 ИСПРАВЛЕНО
          ['get', 'housenumber'],
          ['get', 'ref']
        ],
        'text-font': ['Noto Sans Medium'],
        'text-size': [
          'interpolate',
          ['linear'],
          ['zoom'],
          16, 10
        ],
        'text-allow-overlap': false, // 🔥 РАЗРЕШАЕМ ПЕРЕКРЫТИЕ ДЛЯ ОТЛАДКИ
        'text-ignore-placement': false, // 🔥 ИГНОРИРУЕМ РАЗМЕЩЕНИЕ
        'text-padding': 1,
        'text-rotation-alignment': 'viewport',
        'text-pitch-alignment': 'viewport'
      },
      paint: {
        'text-color': '#FF00FF', // 🔥 MAGENTA ДЛЯ ОТЛИЧИЯ
        'text-halo-color': '#000000',
        'text-halo-width': 1,
        'text-opacity': 1.0
      }
    }
  ]);
}

// 📍 ГОРОДА ИСЧЕЗАЮТ РАНЬШЕ (КОГДА ВИДНЫ ГЛАВНЫЕ ДОРОГИ)
function createPlaceLabelLayers() {
  return memoizeLayer('places', () => [
    {
      id: 'place-country',
      type: 'symbol',
      source: SOURCE_NAME,
      'source-layer': 'places',
      filter: ['==', 'kind', 'country'],
      minzoom: 0,
      maxzoom: 7,
      layout: {
        'text-field': ['get', 'name'],
        'text-font': ['Noto Sans Regular'],
        'text-size': ['interpolate', ['linear'], ['zoom'], 0, 10, 6, 18],
        'text-transform': 'uppercase',
      },
      paint: { 
        'text-color': COLORS.COUNTRY_TEXT,
        'text-halo-color': COLORS.TEXT_HALO_BLACK, 
        'text-halo-width': 1.5,
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 0, 1, 6, 1, 7, 0]
      }
    },
    {
      id: 'place-state',
      type: 'symbol',
      source: SOURCE_NAME,
      'source-layer': 'places',
      filter: ['in', 'kind', 'state', 'region'],
      minzoom: 3,
      maxzoom: 9,
      layout: {
        'text-field': ['get', 'name'],
        'text-font': ['Noto Sans Regular'],
        'text-size': ['interpolate', ['linear'], ['zoom'], 3, 11, 8, 16],
      },
      paint: { 
        'text-color': COLORS.STATE_TEXT,
        'text-halo-color': COLORS.TEXT_HALO_BLACK, 
        'text-halo-width': 1.2,
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 3, 0.7, 6, 1, 8, 1, 9, 0]
      }
    },
    {
      id: 'place-major-capitals',
      type: 'symbol',
      source: SOURCE_NAME,
      'source-layer': 'places',
      filter: ['all', 
        ['==', 'kind', 'locality'],
        ['has', 'capital'],
        ['>=', 'population_rank', 12]
      ],
      minzoom: 2,
      maxzoom: 12,
      layout: {
        'text-field': ['get', 'name'],
        'text-font': ['Noto Sans Medium'],
        'text-size': ['interpolate', ['linear'], ['zoom'], 2, 9, 10, 18, 12, 22],
        'icon-image': 'border-dot-13-dark',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 2, 0.8, 10, 1.4, 12, 1.6],
        'text-anchor': 'top',
        'text-offset': [0, 1.8],
        'text-allow-overlap': false,
        'icon-allow-overlap': false
      },
      paint: { 
        'text-color': COLORS.CITY_TEXT,
        'text-halo-color': COLORS.TEXT_HALO_BLACK, 
        'text-halo-width': 2,
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 2, 0.8, 4, 1, 11, 1, 12, 0],
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 2, 0.8, 4, 1, 11, 1, 12, 0]
      }
    },
    {
      id: 'place-small-capitals',
      type: 'symbol',
      source: SOURCE_NAME,
      'source-layer': 'places',
      filter: ['all', 
        ['==', 'kind', 'locality'],
        ['has', 'capital'],
        ['<', 'population_rank', 12]
      ],
      minzoom: 4,
      maxzoom: 12,
      layout: {
        'text-field': ['get', 'name'],
        'text-font': ['Noto Sans Medium'],
        'text-size': ['interpolate', ['linear'], ['zoom'], 4, 9, 12, 16],
        'icon-image': 'dot-11-dark',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 4, 0.7, 12, 1.2],
        'text-anchor': 'top',
        'text-offset': [0, 1.5],
        'text-allow-overlap': false,
        'icon-allow-overlap': false
      },
      paint: { 
        'text-color': COLORS.CITY_TEXT,
        'text-halo-color': COLORS.TEXT_HALO_BLACK, 
        'text-halo-width': 1.5,
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 4, 0.8, 6, 1, 11, 1, 12, 0],
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 4, 0.8, 6, 1, 11, 1, 12, 0]
      }
    },
    {
      id: 'place-cities-large',
      type: 'symbol',
      source: SOURCE_NAME,
      'source-layer': 'places',
      filter: ['all', 
        ['==', 'kind', 'locality'],
        ['!has', 'capital'],
        ['>=', 'population_rank', 10]
      ],
      minzoom: 4,
      maxzoom: 12,
      layout: {
        'text-field': ['get', 'name'],
        'text-font': ['Noto Sans Regular'],
        'text-size': ['interpolate', ['linear'], ['zoom'], 4, 8, 12, 14],
        'icon-image': 'dot-11-dark',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 4, 0.6, 12, 1.1],
        'text-anchor': 'top',
        'text-offset': [0, 1.5],
        'text-allow-overlap': false,
        'icon-allow-overlap': false
      },
      paint: { 
        'text-color': COLORS.CITY_TEXT,
        'text-halo-color': COLORS.TEXT_HALO_BLACK, 
        'text-halo-width': 1.5,
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 4, 0.7, 6, 1, 11, 1, 12, 0],
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 4, 0.7, 6, 1, 11, 1, 12, 0]
      }
    },
    {
      id: 'place-cities-small',
      type: 'symbol',
      source: SOURCE_NAME,
      'source-layer': 'places',
      filter: ['all', 
        ['==', 'kind', 'locality'],
        ['!has', 'capital'],
        ['<', 'population_rank', 10],
        ['>=', 'population_rank', 6]
      ],
      minzoom: 6,
      maxzoom: 12,
      layout: {
        'text-field': ['get', 'name'],
        'text-font': ['Noto Sans Regular'],
        'text-size': ['interpolate', ['linear'], ['zoom'], 6, 7, 12, 12],
        'icon-image': 'dot-10-dark',
        'icon-size': ['interpolate', ['linear'], ['zoom'], 6, 0.5, 12, 0.9],
        'text-anchor': 'top',
        'text-offset': [0, 1.3],
        'text-allow-overlap': false,
        'icon-allow-overlap': false
      },
      paint: { 
        'text-color': COLORS.TOWN_TEXT,
        'text-halo-color': COLORS.TEXT_HALO_BLACK, 
        'text-halo-width': 1.5,
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 6, 0.7, 8, 1, 11, 1, 12, 0],
        'icon-opacity': ['interpolate', ['linear'], ['zoom'], 6, 0.7, 8, 1, 11, 1, 12, 0]
      }
    },
    {
      id: 'place-neighbourhoods',
      type: 'symbol',
      source: SOURCE_NAME,
      'source-layer': 'places',
      filter: ['in', 'kind', 'neighbourhood', 'macrohood'],
      minzoom: 12,
      layout: {
        'text-field': ['get', 'name'],
        'text-font': ['Noto Sans Regular'],
        'text-size': ['interpolate', ['linear'], ['zoom'], 12, 8, 18, 12],
        'text-allow-overlap': false
      },
      paint: { 
        'text-color': COLORS.NEIGHBORHOOD_TEXT,
        'text-halo-color': COLORS.TEXT_HALO_DARK, 
        'text-halo-width': 1,
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 12, 0.6, 14, 1]
      }
    }
  ]);
}

// 🛣️ ДОРОГИ  
function createRoadLayers() {
  return memoizeLayer('roads', () => [
    // 🛣️ АВТОМАГИСТРАЛИ с усиленным градиентом
    {
      id: 'road-highway',
      type: 'line',
      source: SOURCE_NAME,
      'source-layer': 'roads',
      filter: ['==', 'kind', 'highway'],
      minzoom: 3,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          3, '#1A1A1C',
          8, '#1C1C1E', 
          12, '#1E1E20',
          15, '#2A2A2C'
        ],
        'line-width': ['interpolate', ['linear'], ['zoom'], 3, 0.5, 8, 3, 12, 6, 16, 12, 20, 16],
        'line-opacity': ['interpolate', ['linear'], ['zoom'], 3, 0.8, 5, 1],
        'line-blur': ['interpolate', ['linear'], ['zoom'], 3, 0, 8, 2, 15, 4]
      }
    },
    // 🛤️ ГЛАВНЫЕ ДОРОГИ с усиленным градиентом
    {
      id: 'road-major',
      type: 'line',
      source: SOURCE_NAME,
      'source-layer': 'roads',
      filter: ['==', 'kind', 'major_road'],
      minzoom: 6,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          6, '#222224',
          10, '#252527',
          15, '#2A2A2C'
        ],
        'line-width': ['interpolate', ['linear'], ['zoom'], 6, 0.5, 10, 2, 16, 6, 20, 8],
        'line-opacity': ['interpolate', ['linear'], ['zoom'], 6, 0.7, 8, 1],
        'line-blur': ['interpolate', ['linear'], ['zoom'], 6, 0, 12, 1.5, 18, 3]
      }
    },
    // 🛣️ ВТОРОСТЕПЕННЫЕ ДОРОГИ
    {
      id: 'road-minor',
      type: 'line',
      source: SOURCE_NAME,
      'source-layer': 'roads',
      filter: ['==', 'kind', 'minor_road'],
      minzoom: 10,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          10, '#2E2E30',
          15, '#32323A'
        ],
        'line-width': ['interpolate', ['linear'], ['zoom'], 10, 0.3, 14, 1.5, 18, 4],
        'line-opacity': ['interpolate', ['linear'], ['zoom'], 10, 0.6, 12, 1],
        'line-blur': ['interpolate', ['linear'], ['zoom'], 10, 0, 15, 0.2]
      }
    },
    // 🏘️ ЖИЛЫЕ ДОРОГИ
    {
      id: 'road-residential',
      type: 'line',
      source: SOURCE_NAME,
      'source-layer': 'roads',
      filter: ['in', 'kind', 'residential', 'service'],
      minzoom: 12,
      paint: {
        'line-color': [
          'interpolate',
          ['linear'],
          ['zoom'],
          12, '#404048',
          18, '#4A4A50'
        ],
        'line-width': ['interpolate', ['linear'], ['zoom'], 12, 0.3, 16, 2, 20, 4],
        'line-opacity': ['interpolate', ['linear'], ['zoom'], 12, 0.5, 14, 1]
      }
    }
  ]);
}

function createRoadLabelLayers() {
  return memoizeLayer('roadLabels', () => [
    {
      id: 'road-label-highway',
      type: 'symbol',
      source: SOURCE_NAME,
      'source-layer': 'roads',
      filter: ['all', ['==', 'kind', 'highway'], ['has', 'name']],
      minzoom: 6,
      layout: {
        'text-field': ['coalesce', ['get', 'name'], ['get', 'ref']],
        'text-font': ['Noto Sans Regular'],
        'text-size': ['interpolate', ['linear'], ['zoom'], 6, 8, 12, 12, 18, 16],
        'symbol-placement': 'line',
        'text-rotation-alignment': 'map',
        'text-max-angle': 30
      },
      paint: {
        'text-color': COLORS.HIGHWAY_TEXT,
        'text-halo-color': COLORS.TEXT_HALO_DARK,
        'text-halo-width': 2,
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 6, 0.7, 8, 1]
      }
    },
    {
      id: 'road-label-major',
      type: 'symbol',
      source: SOURCE_NAME,
      'source-layer': 'roads',
      filter: ['all', ['==', 'kind', 'major_road'], ['has', 'name']],
      minzoom: 8,
      layout: {
        'text-field': ['get', 'name'],
        'text-font': ['Noto Sans Regular'],
        'text-size': ['interpolate', ['linear'], ['zoom'], 8, 7, 14, 11, 18, 14],
        'symbol-placement': 'line',
        'text-rotation-alignment': 'map',
        'text-max-angle': 30
      },
      paint: {
        'text-color': COLORS.MAJOR_TEXT,
        'text-halo-color': COLORS.TEXT_HALO_DARK,
        'text-halo-width': 1.5,
        'text-opacity': ['interpolate', ['linear'], ['zoom'], 8, 0.7, 10, 1]
      }
    }
  ]);
}

// 🎯 ПОЛНОСТЬЮ УНИФИЦИРОВАННЫЕ POI СЛОИ С ЦВЕТАМИ ПО ИКОНКАМ
function createPoiLayers() {
  return memoizeLayer('poi', () => {
    const layers = [];
    
    Object.entries(POI_ICON_MAPPING).forEach(([poiKind, config]) => {
      const layer = {
        id: `poi-${poiKind}`,
        type: 'symbol',
        source: SOURCE_NAME,
        'source-layer': 'pois',
        filter: ['==', 'kind', poiKind],
        minzoom: config.minzoom,
        layout: {
          'icon-image': config.icon,
          'icon-size': 1.2,
          'text-allow-overlap': false,
          'icon-allow-overlap': false,
          'text-max-width': 8,
          'icon-optional': false
        },
        paint: {
          'icon-opacity': 1.0
        }
      };

      // 🎨 НАСТРАИВАЕМЫЙ ТЕКСТ С ЦВЕТОМ ПО ИКОНКЕ
      if (config.showText) {
        layer.layout['text-field'] = ['get', 'name'];
        layer.layout['text-font'] = ['Noto Sans Medium'];
        layer.layout['text-size'] = 11;
        layer.layout['text-anchor'] = 'top';
        layer.layout['text-offset'] = [0, 1.2];
        layer.layout['text-optional'] = true;
        
        if (config.textTransform !== 'none') {
          layer.layout['text-transform'] = config.textTransform;
        }
        
        // 🎨 ЦВЕТ ТЕКСТА СООТВЕТСТВУЕТ ЦВЕТУ ИКОНКИ
        const iconColor = POI_ICON_COLORS[config.icon] || POI_ICON_COLORS['default'];
        layer.paint['text-color'] = iconColor;
        layer.paint['text-halo-color'] = COLORS.TEXT_HALO_BLACK;
        layer.paint['text-halo-width'] = 1.5;
        layer.paint['text-opacity'] = 1.0;
      }

      layers.push(layer);
    });

    return layers;
  });
}

// 🚀 БЫСТРОЕ СОЗДАНИЕ СТИЛЯ
export async function createMAPIMapStyle() {
  console.log('🌊 Creating POI with ICON-MATCHED TEXT COLORS + HOUSE NUMBERS WITH DEBUG...');

  const tileUrlTemplate = `${baseUrl}/tiles/{z}/{x}/{y}`;

  // ПАРАЛЛЕЛЬНАЯ ПРЕДЗАГРУЗКА
  const [baseLayers] = await Promise.all([
    Promise.resolve(layers(SOURCE_NAME, namedFlavor('dark'))),
    fetch(ASSETS_CONFIG.sprite + '.json').catch(() => null),
    fetch(ASSETS_CONFIG.fonts.replace('{fontstack}', 'Noto Sans Regular').replace('{range}', '0-255')).catch(() => null)
  ]);

  const filteredBaseLayers = baseLayers
    .filter(layer => {
      const keepLayer = !layer.id.startsWith('pois') && 
                       !layer.id.startsWith('places') && 
                       !layer.id.startsWith('roads') &&
                       !layer.id.startsWith('landuse') &&
                       !layer.id.startsWith('buildings') &&
                       !layer.id.includes('labels');
      return keepLayer;
    })
    .map(layer => {
      if (layer.layout && layer.layout['text-font']) {
        layer.layout['text-font'] = ['Noto Sans Regular'];
      }
      
      if (layer.id === 'background') {
        layer.paint = { 'background-color': COLORS.MAP_BACKGROUND };
      }
      
      return layer;
    });

  // ПАРАЛЛЕЛЬНОЕ СОЗДАНИЕ ВСЕХ СЛОЕВ
  const [
    landuseLayers, 
    buildingLayers, 
    roadLayers, 
    roadLabelLayers, 
    houseNumberLayers,
    poiLayers, 
    placeLabelLayers
  ] = await Promise.all([
    createLanduseLayers(),
    createBuildingLayers(), 
    createRoadLayers(),
    createRoadLabelLayers(),
    createHouseNumberLayers(),
    createPoiLayers(),
    createPlaceLabelLayers()
  ]);

  const style = {
    version: 8,
    name: 'MAPI POI with Icon-Matched Text Colors + House Numbers DEBUG',
    glyphs: ASSETS_CONFIG.fonts,
    sprite: ASSETS_CONFIG.sprite,
    sources: {
      [SOURCE_NAME]: {
        type: 'vector',
        tiles: [tileUrlTemplate],
        attribution: 'mapi.one',
        minzoom: 0,
        maxzoom: 15,
        scheme: 'xyz',
        tileSize: 512,
        buffer: 64
      },
    },
    layers: [
      ...filteredBaseLayers,
      ...landuseLayers,
      ...buildingLayers,
      ...roadLayers,
      ...roadLabelLayers,
      ...houseNumberLayers,
      ...poiLayers,
      ...placeLabelLayers,
    ],
  };

  console.log(`🌊 POI with Icon-Matched Text Colors + House Numbers DEBUG created!`);
  console.log(`🔍 DEBUG MODE: House numbers now visible at zoom 14+ with bright yellow color`);
  console.log(`🏠 Red overlay shows all buildings at zoom 17+`);
  console.log(`🎨 Different colors for different source layers:`);
  console.log(`   - Yellow: buildings layer`);
  console.log(`   - Cyan: pois layer`);
  console.log(`   - Magenta: places layer`);
  
  return style;
}

// 🚀 УЛУЧШЕННЫЙ АНАЛИЗАТОР С ГЛУБОКОЙ ОТЛАДКОЙ
export function analyzeMAPIPOI(map) {
  if (!map) return;

  console.log('🌊 === DEEP MAPI DATA ANALYZER ===');
  console.log('🔍 This will help find where house numbers are stored');
  console.log('============================================\n');

  // 🔍 АНАЛИЗ ВСЕХ ДОСТУПНЫХ СЛОЕВ ПРИ ЗАГРУЗКЕ
  map.on('load', () => {
    console.log('🔍 === DEEP SOURCE LAYER ANALYSIS ===');
    
    // Проверяем все слои в стиле
    const style = map.getStyle();
    const layers = style.layers || [];
    const sources = style.sources || {};
    
    console.log('📦 Available sources:');
    Object.entries(sources).forEach(([name, source]) => {
      if (source.type === 'vector') {
        console.log(`  🗺️ Vector source: ${name}`);
        console.log(`     Tiles: ${source.tiles?.[0] || 'None'}`);
      }
    });
    
    console.log('\n📋 All layers in style:');
    const vectorLayers = layers.filter(l => l.source === SOURCE_NAME);
    vectorLayers.forEach(layer => {
      console.log(`  📄 Layer: ${layer.id}`);
      console.log(`     Source-layer: ${layer['source-layer'] || 'None'}`);
      console.log(`     Type: ${layer.type}`);
      if (layer.filter) {
        console.log(`     Filter: ${JSON.stringify(layer.filter).substring(0, 100)}...`);
      }
    });
    
    // Попробуем загрузить тайл напрямую для анализа структуры
    const center = map.getCenter();
    const zoom = Math.floor(map.getZoom());
    const tileCoord = latLngToTile(center.lat, center.lng, zoom);
    
    console.log(`\n🎯 Current location analysis:`);
    console.log(`   Center: ${center.lat.toFixed(6)}, ${center.lng.toFixed(6)}`);
    console.log(`   Zoom: ${zoom}`);
    console.log(`   Tile coordinates: ${tileCoord.x}, ${tileCoord.y}, ${tileCoord.z}`);
    
    console.log('=== END DEEP ANALYSIS ===\n');

    // 🎮 Устанавливаем глобальные функции для отладки
    window.checkRegionData = (lat, lng, zoom = 16) => {
      console.log(`\n🌍 === CHECKING REGION DATA ===`);
      console.log(`Location: ${lat}, ${lng} at zoom ${zoom}`);
      
      map.flyTo({
        center: [lng, lat],
        zoom: zoom,
        duration: 1000
      });
      
      setTimeout(() => {
        const point = map.project([lng, lat]);
        const features = map.queryRenderedFeatures(point);
        
        console.log(`Found ${features.length} features at this location`);
        
        const uniqueSourceLayers = [...new Set(features.map(f => f.sourceLayer))];
        console.log(`Source layers: ${uniqueSourceLayers.join(', ')}`);
        
        const addressFeatures = features.filter(f => {
          const props = f.properties || {};
          return Object.keys(props).some(key => 
            key.toLowerCase().includes('addr') ||
            key.toLowerCase().includes('house') ||
            key.toLowerCase().includes('number')
          );
        });
        
        console.log(`Features with address data: ${addressFeatures.length}`);
        
        if (addressFeatures.length > 0) {
          console.log('🎉 FOUND ADDRESS DATA!');
          addressFeatures.forEach(feature => {
            const props = feature.properties;
            console.log(`Source: ${feature.sourceLayer}`);
            Object.keys(props).forEach(key => {
              if (key.toLowerCase().includes('addr') || 
                  key.toLowerCase().includes('house') || 
                  key.toLowerCase().includes('number')) {
                console.log(`  ${key}: "${props[key]}"`);
              }
            });
          });
        }
        
        console.log('=== END REGION CHECK ===\n');
      }, 1500);
    };

    // 🎯 Функция для проверки популярных городов
    window.checkPopularCities = () => {
      const cities = [
        { name: 'New York', lat: 40.7128, lng: -74.0060 },
        { name: 'London', lat: 51.5074, lng: -0.1278 },
        { name: 'Paris', lat: 48.8566, lng: 2.3522 },
        { name: 'Berlin', lat: 52.5200, lng: 13.4050 },
        { name: 'Moscow', lat: 55.7558, lng: 37.6173 },
        { name: 'Tokyo', lat: 35.6762, lng: 139.6503 }
      ];
      
      console.log('🌍 Testing popular cities for house number data...');
      
      cities.forEach((city, index) => {
        setTimeout(() => {
          console.log(`\n🌆 Testing ${city.name}...`);
          window.checkRegionData(city.lat, city.lng, 17);
        }, index * 3000);
      });
    };

    console.log('\n🎮 === AVAILABLE DEBUG COMMANDS ===');
    console.log('window.checkRegionData(lat, lng, zoom) - Check specific location');
    console.log('window.checkPopularCities() - Test multiple cities');
    console.log('Click anywhere on map for detailed analysis');
    console.log('=====================================\n');
  });


  // 🎯 ЗУМ АНАЛИЗАТОР
  map.on('zoom', () => {
    const zoom = Math.round(map.getZoom() * 10) / 10;
    if (zoom >= 14 && zoom <= 14.5) {
      console.log(`🔍 Zoom ${zoom}: House numbers should be visible now (bright yellow)`);
    }
    if (zoom >= 17 && zoom <= 17.5) {
      console.log(`🔍 Zoom ${zoom}: Building debug overlay should be visible (red)`);
    }
  });
}

// 🎨 ЭКСПОРТ ЦВЕТОВОЙ ПАЛИТРЫ ДЛЯ РЕДАКТИРОВАНИЯ
export { COLORS, POI_ICON_COLORS };